// extracted by mini-css-extract-plugin
module.exports = {"attractionId":"SearchFilters_attractionId__3ZClA","lang":"SearchFilters_lang__3WoiV"};